import { useGetPlansList } from '@pages/Checkout/hooks/useGetPlansList'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { Loader } from '@ui-kit'
import { Row } from 'simple-flexbox'

import { Plan } from './components/Plan'

export const PlanPanels = () => {
  const plans = useGetPlansList()

  const {
    chosenBillingPeriod,
    isCurrentPlan,
    accountCurrency,
    getPlanPrice,
    packagesIsLoading,
    getAnnualSavingPrice
  } = useCheckoutContext()

  return (
    <Row horizontal='center'>
      {packagesIsLoading ? (
        <Loader />
      ) : (
        plans.map(plan => (
          <Plan
            key={plan.recordKey}
            currency={accountCurrency}
            price={getPlanPrice(plan.recordKey)}
            isCurrent={isCurrentPlan(plan.recordKey)}
            billingPeriod={chosenBillingPeriod}
            annualSavingPrice={getAnnualSavingPrice(plan.recordKey)}
            {...plan}
          />
        ))
      )}
    </Row>
  )
}

PlanPanels.displayName = 'CheckoutPlansPlanPanels'
